export default {
  geolocation: {
    lat: '39.7805',
    lng: '32.7181',
    label: '06750 Ankara',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
